import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react'
import {
  useModalAction,
  useModalState,
} from '@components/common/modal/modal.context'
import { productPopups } from '@components/product/component-options'
import { useStore } from '@contexts/store'
import { isEmpty } from 'lodash'
import dynamic from 'next/dynamic'

const LoginForm = dynamic(() => import('@components/auth/login-form'))
const SignUpForm = dynamic(() => import('@components/auth/sign-up-form'))
const ForgetPasswordForm = dynamic(
  () => import('@components/auth/forget-password-form'),
)

const AddressPopup = dynamic(
  () => import('@components/common/form/add-edit-address'),
)
const OrderPaymentPopup = dynamic(
  () => import('@components/order/order-payment'),
)

const ShippingPolicy = dynamic(
  () => import('@components/policies/shipping-policy'),
)
const AllPolicies = dynamic(() => import('@components/policies/all-policies'))
const ReturnPolicy = dynamic(() => import('@components/policies/return-policy'))

const DownloadDigitalProduct = dynamic(
  () => import('@components/order/download-digital-product'),
)
const ConfirmAccountEmail = dynamic(
  () => import('@components/my-account/confirm-account-email'),
)

const FindMyOrder = dynamic(
  () => import('@components/order/order-search-modal'),
)
const StoreIsPending = dynamic(
  () => import('@components/layout/StoreIsPending'),
)

const CustomDomainExpired = dynamic(
  () => import('@components/layout/custom-domain-expired'),
)

const ManagedModal: React.FC = () => {
  const { isOpen, view, modalOptions } = useModalState()
  const { closeModal: onClose } = useModalAction()

  const { storeTemplate } = useStore()

  const ProductPopup = productPopups[storeTemplate]

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      isCentered={false}
      {...modalOptions}
    >
      {modalOptions?.showOverlay === false ? (
        <></>
      ) : (
        <ModalOverlay {...modalOptions?.contentStyle?.overlayOptions} />
      )}
      <ModalContent
        mx={{ base: '1', xl: '0' }}
        {...modalOptions?.contentStyle?.contentBoxProperties}
      >
        {/* <ModalHeader>Modal Title</ModalHeader> */}
        {!modalOptions?.hideCloseButton && <ModalCloseButton />}
        <ModalBody
          m={0}
          py={2}
          px={{ base: 0, lg: 2 }}
          {...modalOptions?.contentStyle?.contentBodyProperties}
        >
          {view === 'LOGIN_VIEW' && <LoginForm />}
          {view === 'SIGN_UP_VIEW' && <SignUpForm />}
          {view === 'FORGET_PASSWORD' && <ForgetPasswordForm />}
          {view === 'ADDRESS_VIEW_AND_EDIT' && <AddressPopup />}
          {view === 'PRODUCT_VIEW' && <ProductPopup />}
          {view === 'ORDER_PAYMENT' && <OrderPaymentPopup />}
          {view === 'SHIPPING_POLICY' && <ShippingPolicy />}
          {view === 'RETURN_POLICY' && <ReturnPolicy />}
          {view === 'ALL_POLICIES' && <AllPolicies />}
          {view === 'DOWNLOAD_DIGITAL_PRODUCT' && <DownloadDigitalProduct />}
          {view === 'CONFIRM_ACCOUNT_EMAIL' && <ConfirmAccountEmail />}
          {view === 'FIND_MY_ORDER' && <FindMyOrder />}
          {view === 'STORE_COMING_SOON' && <StoreIsPending />}
          {view === 'DOMAIN_REDIRECT' && <CustomDomainExpired />}
          {/*{view === 'ADDRESS_VIEW_AND_EDIT' && <AddressPopup />}
      {view === 'PAYMENT' && <PaymentPopup />}
      {view === 'PHONE_NUMBER' && <PhoneNumberPopup />}
      {view === 'DELIVERY_VIEW' && <DeliveryAddresses />} */}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ManagedModal
